module.exports = __webpack_public_path__ + "img/logo2-dark.3edaa893.png";